export const isSlot = (element) => {
    if (!element || typeof element !== 'object') {
        return;
    }
    return element.tagName === 'SLOT';
};
